import { WorkitemSchema } from '@rhythmic/types'
import type { CollectionBuildRequestConfig } from '../CollectionRegistry/CollectionBuilder.types'

export const WORKITEM_TABLE = '"public"."workitems"'
export const WORKITEM_ENDPOINT = '/api/workitems'
export const WorkitemConfig: CollectionBuildRequestConfig = {
  collectionType: 'electric',
  table: WORKITEM_TABLE,
  partitionKey: 'team_id',
  key: 'id',
  apiEndpoint: WORKITEM_ENDPOINT,
  where: {},
  schema: WorkitemSchema,
}
